// Shared fields for race create/edit. Errors render inline (ApiError.fields
// + client-side validation).

export default function RaceFields({ form, setField, fieldError, disabled, showStatus = false }) {
    return (
        <div className="cat-form__grid">
            <label className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Nombre</span>
                <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setField('name', e.target.value)}
                    maxLength={80}
                    disabled={disabled}
                    autoFocus
                    aria-invalid={!!fieldError('name')}
                />
                {fieldError('name') && <span className="cat-form__error" role="alert">{fieldError('name')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Código</span>
                <input
                    type="text"
                    value={form.code}
                    onChange={(e) => setField('code', e.target.value)}
                    maxLength={20}
                    disabled={disabled}
                    placeholder="Opcional (ej. GYR)"
                    aria-invalid={!!fieldError('code')}
                />
                {fieldError('code') && <span className="cat-form__error" role="alert">{fieldError('code')}</span>}
            </label>

            {showStatus && (
                <label className="cat-form__field">
                    <span className="cat-form__label">Estado</span>
                    <select
                        value={form.status}
                        onChange={(e) => setField('status', Number(e.target.value))}
                        disabled={disabled}
                    >
                        <option value={2}>Activo</option>
                        <option value={1}>Inactivo</option>
                    </select>
                </label>
            )}
        </div>
    );
}
